// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
// kaleem 2021-0228 - Bootstrap config -BEGIN Add
import "bootstrap"
// import "../stylesheets/application"
// import "../../assets/stylesheets/application"

// import "jquery"
import  "autonumeric"

// = require autonumericE

// Kaleem 06-2024 - disable this. New fonawesome 6.0.0 has been added via gem "font-awesome-sass"
//import '@fortawesome/fontawesome-free/scss/fontawesome';
//import '@fortawesome/fontawesome-free/scss/solid';
//import '@fortawesome/fontawesome-free/scss/regular';
//import '@fortawesome/fontawesome-free/scss/brands';
//import '@fortawesome/fontawesome-free/scss/v4-shims';
//import "@fortawesome/fontawesome-free/js/all";
//import "@fortawesome/fontawesome-free/css/all";

// kaleem 01/03/2022 - ChartJS config
//import Chart from 'chart.js/auto';

// kaleem 06/06/24 
require("jquery")

// Kaleem 
import { createConsumer } from "@rails/actioncable"
window.App = {}
App.cable = createConsumer()

Rails.start()
Turbolinks.start()
ActiveStorage.start()

// kaleem 2021-0228 - Bootstrap config -BEGIN

document.addEventListener("turbolinks:load", () => {
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
  $('.toast').toast({ autohide: false })
  $('#toast').toast('show')
})
// kaleem 2021-0228 - Bootstrap config -END Add

// kaleem 01/03/2022 - ChartJS config - BEGIN
document.addEventListener('turbolinks:load', () => {
  var ctx = document.getElementById('myChart').getContext('2d');
  var myChart = new Chart(ctx, {
  type: 'line',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      borderColor: '#00FF00',
      label: ctx.canvas.dataset.label,
      data: JSON.parse(ctx.canvas.dataset.data),
    }]
  },
  });
})

document.addEventListener('turbolinks:load', () => {
  var ctx2 = document.getElementById('myChart2').getContext('2d');
  var myChart2 = new Chart(ctx2, {
  type: 'line',
  data: {
    labels: JSON.parse(ctx2.canvas.dataset.labels),
    datasets: [{
      borderColor: '#00FF00',
      label: ctx2.canvas.dataset.label,
      data: JSON.parse(ctx2.canvas.dataset.data),
    },
    {
      borderColor: '#FF6347',
      label: ctx2.canvas.dataset.label2,
      data: JSON.parse(ctx2.canvas.dataset.data2),
    }    
  ]
  },
  });
})

document.addEventListener('turbolinks:load', () => {
  var ctx = document.getElementById('myBarChart').getContext('2d');
  var myChart = new Chart(ctx, {
  type: 'bar',
  data: {
    labels: JSON.parse(ctx2.canvas.dataset.labels),
    datasets: [{
      borderColor: 'blue',
      backgroundColor: "blue",
      label: ctx.canvas.dataset.label,
      data: JSON.parse(ctx.canvas.dataset.data),
    },
    {
      borderColor:"red",
      backgroundColor: "red",
      label: ctx.canvas.dataset.label2,
      data: JSON.parse(ctx.canvas.dataset.data2),
    } 

  ]
  },
  options: {
    indexAxis: 'y',
    // Elements options apply to all of the options unless overridden in a dataset
    // In this case, we are setting the border of each horizontal bar to be 2px wide
    elements: {
      bar: {
        borderWidth: 2,
      }
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'right',
      },
      title: {
        display: true,
        text: 'Chart.js Horizontal Bar Chart'
      }
    }
  },
  });
})

document.addEventListener('turbolinks:load', () => {
  var ctx = document.getElementById('myStackedBarChart').getContext('2d');
  var myChart = new Chart(ctx, {
  type: 'bar',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      borderColor: 'green',
      backgroundColor: "blue",
      label: ctx.canvas.dataset.label,
      data: JSON.parse(ctx.canvas.dataset.data),
    },
    {
      borderColor:"red",
      backgroundColor: "red",
      label: ctx.canvas.dataset.label2,
      data: JSON.parse(ctx.canvas.dataset.data2),
    },
    {
      borderColor:"blue",
      backgroundColor: "green",
      label: ctx.canvas.dataset.label3,
      data: JSON.parse(ctx.canvas.dataset.data3),
    },
    {
      borderColor:"yellow",
      backgroundColor: "yellow",
      label: ctx.canvas.dataset.label4,
      data: JSON.parse(ctx.canvas.dataset.data4),
    }           
  ]
  },
  options: {
    responsive: true,
    // maintainAspectRatio: false,
    // aspectRatio: 1.0,
    // indexAxis: 'y',
    // Elements options apply to all of the options unless overridden in a dataset
    // In this case, we are setting the border of each horizontal bar to be 2px wide
    // elements: {
    //   bar: {
    //     borderWidth: 2,
    //   }
    // },

    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true
      }
    },
    plugins: {
      // legend: {
      //   position: 'right',
      // },
      title: {
        display: true,
        text: 'Your data overview for the past 6 Months'
      },
      // disable legend interaction
      legend: {
        onClick: (e) => e.stopPropagation()
      },
    }
  },
  });
})

document.addEventListener('turbolinks:load', () => {
  var ctx = document.getElementById('myDoughnutChart').getContext('2d');
  var myChart = new Chart(ctx, {
  type: 'doughnut',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      // borderColor: 'green',
      backgroundColor: ["blue", "red", "green","yellow"],
      label: ctx.canvas.dataset.label,
      data: JSON.parse(ctx.canvas.dataset.data),
    }           
  ]
  },
  options: {
    responsive: true,
    // aspectRatio: 3,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'What is Active Today'
      },

      // disable legend interaction
      legend: {
        onClick: (e) => e.stopPropagation()
      },      
    }
  },
  });
})

// kaleem 01/03/2022 - ChartJS config - END


